import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import { message } from 'antd'
import { authApi } from '../api/auth'
import { useAuthStore } from '../stores/authStore'

/** 登录 Mutation */
export function useLogin() {
  const setTokens = useAuthStore((s) => s.setTokens)
  const setUser = useAuthStore((s) => s.setUser)
  const navigate = useNavigate()

  return useMutation({
    mutationFn: authApi.login,
    onSuccess: (data) => {
      setTokens(data.access_token, data.refresh_token)
      setUser(data.user)
      message.success(`欢迎回来，${data.user.display_name}`)
      navigate('/')
    },
    onError: (err: Error) => {
      message.error(err.message)
    },
  })
}

/** 注册 Mutation */
export function useRegister() {
  const setTokens = useAuthStore((s) => s.setTokens)
  const setUser = useAuthStore((s) => s.setUser)
  const navigate = useNavigate()

  return useMutation({
    mutationFn: authApi.register,
    onSuccess: (data) => {
      setTokens(data.access_token, data.refresh_token)
      setUser(data.user)
      message.success(`注册成功，欢迎 ${data.user.display_name}`)
      navigate('/')
    },
    onError: (err: Error) => {
      message.error(err.message)
    },
  })
}

/** 获取用户信息 Query */
export function useProfile(enabled = true) {
  const user = useAuthStore((s) => s.user)
  const setUser = useAuthStore((s) => s.setUser)

  return useQuery({
    queryKey: ['profile'],
    queryFn: async () => {
      const data = await authApi.profile()
      setUser(data)
      return data
    },
    enabled,
    staleTime: 60000,
    initialData: user ?? undefined,
  })
}

/** 登出 */
export function useLogout() {
  const logout = useAuthStore((s) => s.logout)
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  return () => {
    logout()
    queryClient.clear()
    message.success('已退出登录')
    navigate('/login')
  }
}
